import { canonicalStringify, getCanonicalFnv1a64Hash } from "@fate-kingdom/shared";

import type { GameState } from "../types";

export function getStateHash(state: Readonly<GameState>): string {
  return getCanonicalFnv1a64Hash(state);
}

export { canonicalStringify };
